







































































import { Vue, Component, Watch } from "vue-property-decorator"
import api from "../honcierge-api"
import EditAppAffiliate from "@/components/EditAppAffiliate.vue"
import TableItemIsEnabled from "@/components/_share/TableItemIsEnabled.vue"

import { DataTableHeader } from "vuetify/types"
import { AppAffiliate } from "types/appAffiliate"
import { AxiosError } from "axios"

@Component({
  components: { EditAppAffiliate, TableItemIsEnabled },
})
export default class AppAffiliates extends Vue {
  private loading = true
  private dialog = false
  private searchName = ""
  private searchLabel = ""
  private totalPages = 0
  private appAffiliates: AppAffiliate["data"][] = []
  private pagination = {
    sortBy: ["id"],
    sortDesc: [true],
    itemsPerPage: -1,
    page: 1,
  }

  private isEnabledFilters: Array<{
    name: string
    isEnabled: "only_enabled" | "only_disabled" | "all"
  }> = [
    { name: "絞り込みなし", isEnabled: "all" },
    { name: "有効", isEnabled: "only_enabled" },
    { name: "無効", isEnabled: "only_disabled" },
  ]
  private selectedFilter: {
    name: string
    isEnabled: "only_enabled" | "only_disabled" | "all"
  } = { name: "有効", isEnabled: "only_enabled" }

  get headers(): DataTableHeader[] {
    return [
      { text: "名前", value: "name" },
      { text: "ラベル", value: "label" },
      { text: "有効/無効", value: "isEnabled" },
      { text: "操作", value: "action", sortable: false },
    ]
  }

  public created(): void {
    this.getAppAffiliates()
    this.loading = false
  }

  @Watch("pagination.page", { deep: true, immediate: true })
  private onChangePage() {
    this.loading = true
    setTimeout(() => {
      this.getAppAffiliates()
      this.loading = false
    }, 500)
  }

  private getAppAffiliates(page?: number) {
    api
      .getAppAffiliates(
        this.searchName,
        this.searchLabel,
        this.selectedFilter.isEnabled,
        this.pagination.sortBy[0],
        this.pagination.sortDesc[0],
        page ? page : this.pagination.page,
        10
      )
      .then((res) => {
        this.totalPages = res.data.meta.totalPages
        this.appAffiliates.length = 0
        this.appAffiliates = res.data.appAffiliates
      })
      .catch((e: AxiosError) => {
        console.log(e.stack)
      })
  }

  private searchAppAffiliates() {
    this.resetPagination()
    this.getAppAffiliates()
  }

  private resetPagination() {
    this.pagination.page = 1
  }

  private updateAppAffiliate(appAffiliate: AppAffiliate["data"]) {
    const target = this.appAffiliates.find((c) => c.id === appAffiliate.id)
    if (target) {
      // 更新
      target.name = appAffiliate.name
      target.label = appAffiliate.label
      target.isEnabled = appAffiliate.isEnabled
    } else {
      // 新規作成
      this.appAffiliates.push(appAffiliate)
    }

    this.close()
  }

  private open(item?: AppAffiliate["data"]) {
    const editAppAffiliate = this.$refs.editAppAffiliate as InstanceType<
      typeof EditAppAffiliate
    >
    if (item) {
      // 更新
      editAppAffiliate.id = item.id
      editAppAffiliate.name = item.name
      editAppAffiliate.label = item.label
      editAppAffiliate.isEnabled = item.isEnabled
    } else {
      // 新規作成
      editAppAffiliate.id = -1
    }
    this.dialog = true
  }

  private close() {
    this.dialog = false
  }
}
